import React from "react";
import { useUserContext } from "../../../../../Context/UserContext";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const OnlineResources = ({
  textRef5,
  textRef8,
  createJobBoardsHTML,
  createCommunitiesHTML,
  handleOpenJd,
  isUsingLocation,
  setIsUsingLocation,
}) => {
  const { searchLoading, errors } = useUserContext();

  return (
    <div className="mb-4">
      <div
        className={`display-text rounded p-3 open-box`}
        style={{
          minHeight: "100px",
          maxHeight: "auto", // Updated to 'auto'
          overflowY: "auto", // Updated to 'auto'
          display: "block",
        }}
      >
        <div className="search-feature-container">
          <div
            style={{
              width: "100%",
            }}
            className="flex flex-col gap-4"
          >
            <p className="!font-[500] !text-base !leading-5 !capitalize !text-[#2D3E4D] ">
              Suggested Job Boards
            </p>
            <div
              className="feature-box"
              ref={textRef5}
              contentEditable
              spellCheck="false"
              dangerouslySetInnerHTML={createJobBoardsHTML}
            ></div>
          </div>
          <div
            style={{
              width: "100%",
            }}
            className="flex flex-col gap-4"
          >
            <p className="!font-[500] !text-base !leading-5 !capitalize !text-[#2D3E4D] ">
              Communities
            </p>
            <div
              className="feature-box  focus:!border-[#23b574] "
              ref={textRef8}
              contentEditable
              spellCheck="false"
              dangerouslySetInnerHTML={createCommunitiesHTML}
            ></div>
          </div>
        </div>

        <div className="col-12 d-flex justify-content-center flex items-center !justify-between mt-4 pt-3">
          <div
            className="flex items-center gap-3 
            
            "
          >
            <button
              onClick={() => {
                setIsUsingLocation((prevUse) => !prevUse);
              }}
              style={{ fontSize: "24px" }}
              type="button"
              className="flex items-center justify-center rounded-md  w-5 h-5 border-black border-2 text-green-500 "
            >
              {isUsingLocation ? "✔" : ""}
            </button>
            <p className="font-[500] "> Location-Specific results</p>
          </div>
          <div className="d-flex  flex-col items-end gap-20px save-info ">
            {errors && errors.onlineResources && (
              <p className="text-red-500  font-semibold">
                {" "}
                {errors.onlineResources}{" "}
              </p>
            )}
            <button
              onClick={() => handleOpenJd("onlineResources")}
              className="__btn m-0 px-xl-5 w-[295px] !font-[500] !leading-5  !text-base !capitalize  "
              disabled={searchLoading.onlineResourcesLoading}
            >
              {searchLoading && searchLoading.onlineResourcesLoading ? (
                <div
                  className="!flex justify-around  w-full"
                  style={{
                    display: "flex",
                    // justifyContent: "space-between",
                    gap: "2rem",
                    alignItems: "center",
                  }}
                >
                  {/*  <p className="font-semibold leading-5 text-base capitalize text-[#2D3E4D] "></p> */}
                  <p className="mb-0"> Loading…</p>
                  <FontAwesomeIcon icon={faCircleNotch} spin />
                </div>
              ) : (
                "Find online resources"
              )}
            </button>
          </div>
          {/* <div /> */}
        </div>
      </div>
    </div>
  );
};

export default OnlineResources;
